/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import TransInfoModal from './components/TransInfoModal';
import LcstModal from './components/LcstModal';
import ApplyModal from './components/ApplyModal';
import CstInfoModal from './components/CstInfoModal';
import DeclareModal from './components/DeclareModal';
import Complete from '@components/Complete/Complete';
import Notice from '@components/Layout/Notice';
import TransFlagModal from '@components/Layout/TransFlagModal';
import { applyReasons } from './constant/loan';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AmountInput, CustomerInfo, Page, Loading } from '@components';
import { addCommas, removeNonNumeric, removeCommas } from '@helper';
import CertModal from './components/CertModal';
import HighGradeModal from './components/HighGradeModal';
const Loan = () => {
    const {
        LoanStore: {
            amount,
            applyReason,
            applyReasonOther,
            loanComplete,
            updateData,
            reset,
            initStock,
            getList,
            canBorrowedAmount,
            canFinancingAmount,
            collateralStockUIList,
            dailyBorrowingAmount,
            applyDisabled,
            transType,
            getLendBusinessTime,
            dailyTransactionLimit,
            singleTransactionLimit,
            singleTransactionMinimum,
            notBusinessHour,
            loanSwitchVisible,
            isLoading,
            loadingFailed,
            msg,
            transFlagModalVisible,
            closeTransFlagModal,
            lendSwitchMessage,
            errMsg,
            highGradeCollateralSwitch,
        },
        AuthStore: {
            borrowedAmount,
            creditFacilities,
            borrowingAmount,
            updateUserInfo,
            status,
            getIdno,
        },
    } = useStore();
    const navigate = useNavigate();
    const [idno, setIdno] = useState('');
    const [TransMsg, setTransMsg] = useState('作業中，請稍後再申請！');
    useEffect(() => {
        initStock();
        getIdno().then(data => {
            setIdno(data);
        });
    }, []);
    const [show, setShow] = useState(false);
    useEffect(() => {
        getLendBusinessTime();
    }, [transType]);
    useEffect(() => {
        let timeout;
        if (show) {
            timeout = setTimeout(() => setShow(false), 4000);
        }
        if (loanComplete) {
            setTimeout(() => {
                navigate(0);
            }, 3000);
        }
        return () => clearTimeout(timeout);
    }, [show, loanComplete]);
    return (
        <Page>
            <div>
                <form
                    className="container"
                    onSubmit={async e => {
                        e.preventDefault();
                        const [
                            getNewBorrowedAmount,
                            getTransFlag,
                            getRealSync,
                        ] = await updateUserInfo();
                        // 依據TransFlag顯示不同提醒
                        if (getTransFlag === '1') {
                            setTransMsg(
                                '您已完成登入，系統資料尚在更新中，請稍候再申請。'
                            );
                        } else if (getTransFlag === '2') {
                            setTransMsg('作業中，請稍後再申請！');
                        } else if (
                            getTransFlag === '3' &&
                            getRealSync === false
                        ) {
                            setTransMsg(
                                '您已完成登入，系統資料尚在更新中，請稍候再申請。'
                            );
                        }
                        // 20250808加上冷卻中且無成功即時轉檔時間也不可申請
                        if (
                            getTransFlag === '1' ||
                            getTransFlag === '2' ||
                            (getTransFlag === '3' && getRealSync === false)
                        ) {
                            updateData('transFlagModalVisible', true);
                        } else {
                            updateData('transFlagModalVisible', false);
                            if (getNewBorrowedAmount.toString()) {
                                if (notBusinessHour) {
                                    updateData('applyModalVisible', true);
                                } else {
                                    if (
                                        removeCommas(amount) <=
                                        getNewBorrowedAmount
                                    ) {
                                        updateData('applyModalVisible', true);
                                    } else {
                                        updateData('loanCstModalVisible', true);
                                        getList();
                                    }
                                }
                            }
                        }
                    }}
                >
                    <CustomerInfo title={'借款申請'} />
                    <div className="card wow fadeInDown">
                        {isLoading ? (
                            <Loading isLoading={isLoading} />
                        ) : !loanComplete ? (
                            <div className="card-body tab-content">
                                <h3 className="title fw-bolder">
                                    設定借款條件
                                </h3>
                                {/* 借款鎖定 */}
                                <div
                                    className={
                                        loanSwitchVisible
                                            ? 'd-none'
                                            : 'message-box position-relative mb-ng2'
                                    }
                                >
                                    <i className="icon_info list-inline-item align-middle "></i>
                                    <div className="d-sm-inline-block h-r3">
                                        {/* 自即日起，暫停新申請「不限用途款項借貸」借款服務。造成不便敬請見諒。 */}
                                        {lendSwitchMessage}
                                    </div>
                                </div>
                                {/* 非營業借款鎖定 */}
                                {/* {notBusinessHour ? (
                                    <div className="message-box position-relative mb-ng2">
                                        <i className="icon_info list-inline-item align-middle "></i>
                                        <div className="d-sm-inline-block">
                                            非營業時間線上借款暫停服務。
                                        </div>
                                    </div>
                                ) : null} */}
                                <div>
                                    <ul className="formbox row g-4 mb-5">
                                        <li className="col-12">
                                            <label
                                                className="form-label"
                                                onMouseOver={() =>
                                                    setShow(true)
                                                }
                                                onMouseLeave={() =>
                                                    setShow(false)
                                                }
                                            >
                                                借款金額
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip>
                                                            最低
                                                            {singleTransactionMinimum /
                                                                10000}
                                                            萬，單筆上限
                                                            {singleTransactionLimit ===
                                                            0
                                                                ? '無限制'
                                                                : singleTransactionLimit /
                                                                      10000 +
                                                                  '萬'}
                                                            ，單日上限
                                                            {dailyTransactionLimit ===
                                                            0
                                                                ? '無限制'
                                                                : dailyTransactionLimit /
                                                                      10000 +
                                                                  '萬'}
                                                            ，最小單位為仟元
                                                            {notBusinessHour
                                                                ? '，非營業時間借款上限為尚可借金額'
                                                                : null}
                                                        </Tooltip>
                                                    }
                                                    trigger="click"
                                                    show={show}
                                                >
                                                    <i className="icon_point bi-exclamation-circle"></i>
                                                </OverlayTrigger>
                                            </label>
                                            <div className="red-num position-relative ">
                                                <span className="fw-bolder position-absolute">
                                                    $
                                                </span>
                                                <AmountInput
                                                    type="tel"
                                                    className="form-control fw-bolder"
                                                    value={amount}
                                                    onChange={e => {
                                                        let finalValue =
                                                            e.target.value;
                                                        // 單日 dailyTransactionLimit
                                                        // 單筆限制 singleTransactionLimit
                                                        // 單筆最低 singleTransactionMinimum
                                                        // 單日借款總金額 dailyBorrowingAmount
                                                        let dailyCanBorrow =
                                                            dailyTransactionLimit -
                                                            dailyBorrowingAmount;
                                                        // 後台關閉dailyTransactionLimit=0不限制
                                                        if (
                                                            dailyTransactionLimit ===
                                                            0
                                                        ) {
                                                            // borrowedAmount
                                                            if (
                                                                notBusinessHour
                                                            ) {
                                                                dailyCanBorrow =
                                                                    borrowedAmount;
                                                            } else {
                                                                dailyCanBorrow =
                                                                    canBorrowedAmount;
                                                            }
                                                        } else if (
                                                            notBusinessHour &&
                                                            dailyTransactionLimit >
                                                                borrowedAmount
                                                        ) {
                                                            dailyCanBorrow =
                                                                borrowedAmount;
                                                        } else if (
                                                            !notBusinessHour &&
                                                            dailyTransactionLimit >
                                                                canBorrowedAmount
                                                        ) {
                                                            dailyCanBorrow =
                                                                canBorrowedAmount;
                                                        } else if (
                                                            dailyTransactionLimit <
                                                            dailyBorrowingAmount
                                                        ) {
                                                            dailyCanBorrow = 0;
                                                            setShow(true);
                                                        }
                                                        if (
                                                            parseInt(
                                                                removeCommas(
                                                                    finalValue
                                                                )
                                                            ) > dailyCanBorrow
                                                        ) {
                                                            finalValue =
                                                                dailyCanBorrow;
                                                            if (
                                                                singleTransactionLimit !==
                                                                    0 &&
                                                                finalValue >
                                                                    singleTransactionLimit
                                                            ) {
                                                                finalValue =
                                                                    singleTransactionLimit;
                                                                setShow(true);
                                                            }
                                                        } else if (
                                                            singleTransactionLimit !==
                                                                0 &&
                                                            parseInt(
                                                                removeCommas(
                                                                    finalValue
                                                                )
                                                            ) >
                                                                singleTransactionLimit
                                                        ) {
                                                            finalValue =
                                                                singleTransactionLimit;
                                                            setShow(true);
                                                        }
                                                        updateData(
                                                            'amount',
                                                            removeNonNumeric(
                                                                finalValue
                                                            )
                                                        );
                                                    }}
                                                    onBlur={() => {
                                                        if (
                                                            parseInt(
                                                                removeCommas(
                                                                    amount
                                                                )
                                                            ) <
                                                            singleTransactionMinimum
                                                        ) {
                                                            updateData(
                                                                'amount',
                                                                '10000'
                                                            );
                                                            setShow(true);
                                                        }
                                                        if (
                                                            parseInt(
                                                                removeCommas(
                                                                    amount
                                                                )
                                                            ) >
                                                                borrowedAmount &&
                                                            notBusinessHour
                                                        ) {
                                                            setShow(true);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </li>
                                        <li className="col-12">
                                            <label className="form-label">
                                                借款目的
                                            </label>
                                            <div className="select-reason row">
                                                <div
                                                    className={
                                                        applyReason === '6'
                                                            ? 'col-12 col-md-4 mb-3'
                                                            : ''
                                                    }
                                                >
                                                    <select
                                                        className="form-select"
                                                        required
                                                        value={applyReason}
                                                        onChange={e => {
                                                            updateData(
                                                                'applyReason',
                                                                e.target.value
                                                            );
                                                        }}
                                                    >
                                                        {Object.values(
                                                            applyReasons
                                                        ).map(
                                                            (
                                                                applyReason,
                                                                idx
                                                            ) => {
                                                                return (
                                                                    <option
                                                                        key={`applyReason ${idx}`}
                                                                        value={
                                                                            applyReason.value
                                                                        }
                                                                    >
                                                                        {
                                                                            applyReason.label
                                                                        }
                                                                    </option>
                                                                );
                                                            }
                                                        )}
                                                    </select>
                                                </div>
                                                <div
                                                    className={
                                                        applyReason === '07'
                                                            ? 'col-12 col-md-8'
                                                            : ''
                                                    }
                                                >
                                                    <input
                                                        type="text"
                                                        className={
                                                            applyReason === '07'
                                                                ? 'form-control col-8 mt-3 mt-md-0'
                                                                : 'd-none'
                                                        }
                                                        autoComplete="off"
                                                        placeholder="請輸入借款目的"
                                                        value={applyReasonOther}
                                                        onChange={e => {
                                                            updateData(
                                                                'applyReasonOther',
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <ol className="inv-info d-flex flex-nowrap justify-content-between text-center mb-3 mb-md-1">
                                        <li>
                                            統e貸額度
                                            <span>
                                                $
                                                {addCommas(
                                                    removeNonNumeric(
                                                        creditFacilities
                                                    )
                                                )}
                                            </span>
                                        </li>
                                        <ul className="d-flex flex-nowrap">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        統e貸額度和擔保品融通額度取低者為實際可借款總金額
                                                    </Tooltip>
                                                }
                                            >
                                                <li type="button">
                                                    <i className="icon-f1 d-none d-sm-inline"></i>
                                                    <small className="d-sm-none">
                                                        可借款金額上限
                                                    </small>
                                                    <small className="desk-show">
                                                        上限
                                                    </small>
                                                    <span>
                                                        $
                                                        {addCommas(
                                                            removeNonNumeric(
                                                                canBorrowedAmount
                                                            )
                                                        )}
                                                    </span>
                                                </li>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        以下股票，可增加的擔保品融通額度
                                                    </Tooltip>
                                                }
                                            >
                                                <li type="button">
                                                    <i className="icon-f2 d-none d-sm-inline"></i>
                                                    <small className="d-sm-none">
                                                        增加融通額度
                                                    </small>
                                                    <small className="desk-show">
                                                        融通
                                                    </small>
                                                    <span>
                                                        $
                                                        {addCommas(
                                                            removeNonNumeric(
                                                                canFinancingAmount
                                                            )
                                                        )}
                                                    </span>
                                                </li>
                                            </OverlayTrigger>
                                        </ul>
                                    </ol>
                                    <h4 className="title fw-bolder mt-3">
                                        可作為擔保品的庫存明細
                                        <span className="fs-12">
                                            （昨日庫存，僅顯示現股整股，不含零股）
                                        </span>
                                        ，若擔保品不足時於【申請】時可進行增加。
                                    </h4>
                                    <div
                                        className={
                                            highGradeCollateralSwitch
                                                ? 'tag_quality text-center text-white ms-0 d-inline-block cur-pointer'
                                                : 'd-none'
                                        }
                                        onClick={() => {
                                            updateData(
                                                'highGradeModalVisible',
                                                true
                                            );
                                        }}
                                    >
                                        優
                                    </div>
                                    <span
                                        className={
                                            highGradeCollateralSwitch
                                                ? 'text-black2 align-text-bottom fw-bolder cur-pointer'
                                                : 'd-none'
                                        }
                                        onClick={() => {
                                            updateData(
                                                'highGradeModalVisible',
                                                true
                                            );
                                        }}
                                    >
                                        優質擔保品定義
                                    </span>
                                    <p className="title d-sm-none text-end">
                                        前一營業日報價資訊
                                    </p>

                                    <div className="table-freezes overflow-auto">
                                        <table
                                            cellSpacing={0}
                                            className="table table_sty"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        style={{
                                                            width: 40 + 'px',
                                                        }}
                                                    ></th>
                                                    <th>股票代號</th>
                                                    <th>股票名稱</th>
                                                    <th>張數</th>
                                                    <th>
                                                        <div className="h-r">
                                                            收盤價
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip>
                                                                        前一營業日收盤價
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                                            </OverlayTrigger>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div className="h-r2">
                                                            市值
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip>
                                                                        前一營業日市值
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                                            </OverlayTrigger>
                                                        </div>
                                                    </th>
                                                    <th>融通成數</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {collateralStockUIList.map(
                                                    (
                                                        {
                                                            stockNo,
                                                            stockName,
                                                            stockQty,
                                                            closePrice,
                                                            marketVal,
                                                            accommodating,
                                                            hQFlag,
                                                        },
                                                        idx
                                                    ) => {
                                                        return (
                                                            <tr
                                                                key={`collateralStockUIList${idx}`}
                                                            >
                                                                <th>
                                                                    {highGradeCollateralSwitch &
                                                                    (hQFlag ===
                                                                        1) ? (
                                                                        <div className="tag_quality text-center text-white ms-0 d-inline-block">
                                                                            優
                                                                        </div>
                                                                    ) : (
                                                                        <span></span>
                                                                    )}
                                                                </th>
                                                                <th>
                                                                    <span className="co-name">
                                                                        {
                                                                            stockNo
                                                                        }
                                                                    </span>
                                                                </th>
                                                                <td>
                                                                    {stockName}
                                                                </td>
                                                                <td>
                                                                    <div className="num_qut t-r3">
                                                                        {
                                                                            stockQty
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div
                                                                        className={`um_price t-r ${
                                                                            !accommodating
                                                                                ? 'opacity-50'
                                                                                : ''
                                                                        }`}
                                                                    >
                                                                        <span>
                                                                            $
                                                                        </span>
                                                                        {
                                                                            closePrice
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div
                                                                        className={`num_price t-r2 ${
                                                                            !accommodating
                                                                                ? 'opacity-50'
                                                                                : ''
                                                                        }`}
                                                                    >
                                                                        <span>
                                                                            $
                                                                        </span>
                                                                        {addCommas(
                                                                            removeNonNumeric(
                                                                                Math.round(
                                                                                    marketVal *
                                                                                        100
                                                                                ) /
                                                                                    100
                                                                            )
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span
                                                                        className={`fingbox rounded-3 text-center ${
                                                                            !accommodating
                                                                                ? 'opacity-50'
                                                                                : ''
                                                                        }`}
                                                                    >
                                                                        {
                                                                            accommodating
                                                                        }
                                                                        <span>
                                                                            %
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                                        <button
                                            type="button"
                                            className="btn_cancel m-border-0 btn rounded-pill text-end text-sm-center"
                                            onClick={() => {
                                                reset({
                                                    amount: '10000',
                                                    applyReason: '01',
                                                    applyReasonOther: '',
                                                });
                                            }}
                                        >
                                            清 除
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn_check btn rounded-pill text-white"
                                            disabled={
                                                parseInt(amount) +
                                                    borrowingAmount >
                                                    creditFacilities ||
                                                (dailyTransactionLimit !== 0 &&
                                                    dailyTransactionLimit -
                                                        dailyBorrowingAmount <=
                                                        0) ||
                                                applyDisabled ||
                                                !parseInt(amount) ||
                                                (parseInt(
                                                    removeCommas(amount)
                                                ) > borrowedAmount &&
                                                    notBusinessHour) ||
                                                // 借款功能鎖定
                                                !loanSwitchVisible ||
                                                status !== '1'
                                            }
                                        >
                                            申 請
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Complete
                                feature={'借款'}
                                remindText={'審核成功後撥款至您的帳戶'}
                                loadingFailed={loadingFailed}
                                msg={msg}
                            />
                        )}
                        <Notice>
                            <li>
                                24小時皆可借款，系統維護時間
                                (8:00~9:00、15:00-17:00)
                                暫停借款，03:50~06:00申請於06:00後撥款。
                            </li>
                            <li>
                                僅限交割銀行為
                                <a
                                    className="text-decoration-underline px-2 a-blue"
                                    href="https://www.twnch.org.tw/eACH.html#ACH-6"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    eACH 配合銀行
                                </a>
                                ，其餘銀行請改洽營業員申請。
                            </li>
                            <li>
                                發行公司之董事、監察人、經理人及持股超過股份總額百分之十股東，請臨櫃辦理質權設定。
                            </li>
                            <li>
                                擔保品需完成交割，買進股票於T+2日11點可進行增加擔保品。
                            </li>
                        </Notice>
                    </div>
                </form>
                <TransFlagModal
                    visibleHandler={transFlagModalVisible}
                    closeModal={closeTransFlagModal}
                    msg={TransMsg}
                />
                <TransInfoModal transType={transType} />
                <LcstModal />
                <ApplyModal />
                <CstInfoModal />
                <DeclareModal />
                <CertModal msg={errMsg} />
                <HighGradeModal />
            </div>
        </Page>
    );
};
export default observer(Loan);
